import {CarInfoModel} from "@/model/car-info/car-info.model";
import {UserInfoInputModel} from "@/model/user-info/user-info-input.model";

export class UserInfoForRegisterModel extends UserInfoInputModel {

    // ポリシー同意有無
    isCheckedAgree: boolean;

    // 店舗コード
    storeCode: string;

    // お車情報
    car: CarInfoModel = new CarInfoModel;

    public copy(obj: UserInfoForRegisterModel) {
        // 親のコピーを実行
        super.copy(obj);

        if (obj) {
            this.isCheckedAgree = obj.isCheckedAgree;
            this.storeCode = obj.storeCode;
            if (obj.car) {
                this.car.copy(obj.car);
            }
        }
    }
}